import React from 'react';
import { FormattedMessage } from "react-intl";
import TopHeader from '../navigation/TopHeader';
import ExpenseList from './ExpenseList';

function ExpenseStep() {
    return(
        <React.Fragment>
            <TopHeader>
                <h2><FormattedMessage id="topheader.expense.h2" /></h2>
                <p><FormattedMessage id="topheader.expense.p" /></p>
            </TopHeader>
            <div className="screen-content">
                <div className="container">
                    <ExpenseList />
                </div>
            </div>
        </React.Fragment>
    );
}

export default ExpenseStep;